import React from 'react';
import {connect} from 'react-redux';
import EquipmentSummary from './EquipmentSummary';
import EquipmentAccessorySummary from './EquipmentAccessorySummary'
const EquipmentSummaryBlock = ({data, context, equipmentSummary, dealType, currentSubscriber, generalDetails, reasonCode}) => {

  //if (generalDetails.family == "W")
    //return null;


  return <EquipmentAccessorySummary
        data={data}
        context={context}
        equipmentSummary={equipmentSummary}
        dealType={dealType}
        currentSubscriber={currentSubscriber}
        reasonCode={reasonCode}
        />

  // if (dealType == 'Accessory') {
  //   return <EquipmentAccessorySummary
  //       data={data}
  //       context={context}
  //       equipmentSummary={equipmentSummary}
  //       dealType={dealType}
  //       currentSubscriber={currentSubscriber}
  //     />
  // } else {
  //   return <EquipmentSummary
  //     data={data}
  //     context={context}
  //     equipmentSummary={equipmentSummary}
  //     dealType={dealType}
  //     currentSubscriber={currentSubscriber}
  //   />
  // }


};

const mapStateToProps = (state) => {
  return {
    equipmentSummary: state.cellcomTransactionSummary.transactionData.equipmentSummary,
    dealType: state.cellcomTransactionSummary.transactionData.dealType,
    currentSubscriber: state.cellcomTransactionSummary.callular,
    generalDetails: state.cellcomTransactionSummary.transactionData.generalDetails,
    reasonCode: state.cellcomTransactionSummary.transactionData.reasonCode ??
      state.cellcomTransactionSummary.transactionData.generalDetails?.reasonCode,
  };
};

export default connect(mapStateToProps, null)(EquipmentSummaryBlock);
